var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-toast-container",class:`base-toast-container--${_vm.position}`},[_c('transition-group',{staticClass:"base-toast-stack",attrs:{"name":"base-toast-slide","tag":"div"}},_vm._l((_vm.toasts),function(t){return _c('BaseToast',_vm._b({key:t.id,on:{"dismiss":_vm.remove}},'BaseToast',t,false))}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }